import TemplatesPage from './templates';

export default TemplatesPage;
